import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { loginUrl, validateToken } from '../ApiUtils/ApiUtils';
import { ApplicationState } from '../store';

import './Login.css';

interface LoginState {
    value: string;
    selfLogin: boolean;
}

function getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const part = parts.pop();
        if (part) {
            return part.split(';').shift();
        }
    }
    return undefined;
}



type LoginProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class Login extends React.Component<LoginProps, LoginState> {
    constructor(props: LoginProps) {
        super(props);
        
        this.state = {
            value: '',
            selfLogin: false
        };
        /*
        let needTokenValidation = true;
        const token = getCookie('gdscp_userToken');
        if (token !== null) {
            sessionStorage.setItem('gdscp_userToken', 'Bearer ' + token);
        }
        else {
            if (!sessionStorage.getItem('gdscp_userToken')) {
                console.log('no token in url or session storage');
                needTokenValidation = false;
                window.location.assign(loginUrl);
            }
        }
        if (needTokenValidation) {
            validateToken().then(() => {
                this.props.push("console");
            }).catch(() => {
                console.log('invalid token');
                window.location.assign(loginUrl);
            });
        }*/
        let isAuthenticated = getCookie("gdscp_userAuthenticated");
        if (!isAuthenticated) {
            window.location.assign(loginUrl);
        } else {
            this.props.push("console");
        }
    }

    private handleChange = (event: any) => {
        this.setState({
            value: event.target.value
        });
    }

    public render() {
        return (
            <React.Fragment>
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-sm-12 col-md-10 col-lg-8">
                        {this.state.selfLogin && (
                            <section>
                                <form className="viewport-form" id="account" method="post" action="api/login/redirect">
                                    <h2 className="text-center">Sign in</h2>
                                    <hr />
                                    <div asp-validation-summary="All" className="text-danger"></div>
                                    <div className="form-group">
                                        <label>Email</label>
                                        <Input type="email" name="email" value={this.state.value} onChange={this.handleChange} required />
                                        <span className="text-danger"></span>
                                    </div>
                                    <div className="mt-2 form-group text-center">
                                        <button type="submit" className="btn btn-primary">Next</button>
                                    </div>
                                </form>
                            </section>
                        )}
                        {!this.state.selfLogin && (
                            <section className="text-center">
                                <p>Initiating SAML...</p>
                                <FontAwesomeIcon icon={faSpinner} size="3x" spin={true} />
                            </section>
                        )}
                    </div>
                </div>

                {/*<a className="btn btn-primary" href="https://localhost:5011/identity/account/externallogin?provider=GDS">GDS</a>
                <br />
                <br />
                <a className="btn btn-info" href="https://localhost:5011/identity/account/externallogin?provider=LENDINGCLUB">Lending Club</a>
                <br />
                <br />
                <a className="btn btn-info" href="https://localhost:5011/identity/account/externallogin?provider=SALESFORCE">Salesforce</a>*/}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        router: state.router
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
